<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <p></p>
    <span class="md:flex hidden items-center">
      COPYRIGHT &copy; {{ new Date().getFullYear() }}&nbsp;&nbsp;
      <a
        href="https://www.agnicoeagle.com/Home/default.aspx"
        target="_blank"
        rel="nofollow"
      >Agnico Eagle</a>
      <span class="hidden sm:inline-block">, All rights Reserved</span>
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  }
};
</script>
